/* eslint-disable react/prop-types */
import { Map as ImmutableMap } from 'immutable';
//
import React from 'react';
import { useDispatch } from 'react-redux';

// import { datasetsTypes } from 'app-components/flux/datasets';
import { rootUiActions, rootUiTypes } from 'app-components/flux/root-ui';
import { sharesActions, sharesTypes } from 'app-components/flux/shares';

import {
  DIALOG_TYPE as CONFIRMATION_DIALOG_TYPE,
  mkConfirmationDialogProps,
} from 'components/Dialogs/ConfirmationDialog';
import { QDropdownMenu, QMenuDivider, QMenuItem } from 'components/QDropdowns';

// type Props = {
//   dataset: datasetsTypes.Dataset,
//   share: ?any;
// }

const ManageSharesMenu = (props) => {
  const { dataset, share } = props;
  const dispatch = useDispatch();

  const handleDeleteShare = () => {
    dispatch(
      rootUiActions.createDialog(
        rootUiTypes.mkRootUiData({
          id: 'delete-share',
          type: CONFIRMATION_DIALOG_TYPE,
          props: ImmutableMap(
            mkConfirmationDialogProps({
              title: 'Remove',
              content: `After removing, ${share.granteeFirstName} ${share.granteeLastName} will no longer have access to this space.`,
              confirmLabel: 'Continue',
              denyLabel: 'Cancel',
              confirmAction: () => dispatch(sharesActions.deleteShare(share)),
            }),
          ),
        }),
      ),
    );
  };

  const handleResendInvitation = () => {
    const invite = sharesTypes.mkShare({
      id: share.id,
      state: 'INVITED',
    });
    dispatch(sharesActions.updateShare(invite));
  };

  const handleRevokeInvitation = () => {
    dispatch(
      rootUiActions.createDialog(
        rootUiTypes.mkRootUiData({
          id: 'revoke-invitation',
          type: CONFIRMATION_DIALOG_TYPE,
          props: ImmutableMap(
            mkConfirmationDialogProps({
              title: 'Revoke invitation',
              content: `After revoking, ${share.granteeFirstName} ${share.granteeLastName} will no longer be able to accept and access this space.`,
              confirmLabel: 'Continue',
              denyLabel: 'Cancel',
              confirmAction: () => {
                const revoke = sharesTypes.mkShare({
                  id: share.id,
                  state: 'INACTIVE',
                });
                dispatch(sharesActions.updateShare(revoke));
              },
            }),
          ),
        }),
      ),
    );
  };

  return (
    <QDropdownMenu
      id={`manage-shares-menu-button-${dataset.id}`}
      aria-label='Manage share options'
      iconButtonVariant='plain'
      iconButtonSize='small'
    >
      {share.state === 'INVITED' ? (
        <QMenuItem variant='action' label='Resend invitation' onClick={handleResendInvitation} />
      ) : null}
      {share.state === 'INVITED' ? <QMenuDivider /> : null}
      {share.state === 'INVITED' && share.expired ? (
        <QMenuItem
          variant='action'
          label='Remove'
          destructive
          onClick={() => dispatch(sharesActions.deleteShare(share))}
        />
      ) : null}
      {share.state === 'INVITED' && !share.expired ? (
        <QMenuItem variant='action' label='Revoke invitation' destructive onClick={handleRevokeInvitation} />
      ) : null}
      {share.state === 'ACTIVE' ? (
        <QMenuItem variant='action' label='Remove' destructive onClick={handleDeleteShare} />
      ) : null}
      {share.state === 'INACTIVE' || share.state === 'ABANDONED' ? (
        <QMenuItem variant='action' label='Resend invitation' onClick={handleResendInvitation} />
      ) : null}
      {share.state === 'INACTIVE' || share.state === 'ABANDONED' ? <QMenuDivider /> : null}
      {share.state === 'INACTIVE' || share.state === 'ABANDONED' ? (
        <QMenuItem variant='action' label='Remove' destructive onClick={handleDeleteShare} />
      ) : null}
    </QDropdownMenu>
  );
};

export default ManageSharesMenu;
